import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useCallback, useEffect, useMemo, useRef } from 'react';
import { propChildren, propArrayShape, propBool, propFunc, propShape, } from '../../../../helpers/custom-prop-types';
import { useArrayWithIndex } from '../../../../helpers/use/useArray';
import { useBoolState } from '../../../../helpers/use/useHook';
import ProfessionalCard from '../../Professional/Card/ProfessionalCard';
import ProfessionalCardSkeleton from '../../Professional/Card/ProfessionalCardSkeleton';
import CustomSlider from '../../Slider';
const ConsultantSearchProfessionalSlider = (props) => {
    const { config: rawConfig, isLg, isMd, isPre, loading, professionals, showPreModal, titleComponent, } = props;
    const sliderRef = useRef();
    const setSliderRef = useCallback((slide) => {
        sliderRef.current = slide;
    }, [sliderRef]);
    const config = useMemo(() => (Object.assign({ adaptiveHeight: true, arrows: false, infinite: professionals.length > 3, responsive: [
            {
                breakpoint: 1281,
                settings: {
                    infinite: professionals.length > 1,
                    slidesToShow: 1,
                    variableWidth: true,
                },
            },
        ], slidesToShow: 3, swipeToSlide: true, variableWidth: false }, rawConfig)), [professionals, rawConfig]);
    const fillCount = useMemo(() => {
        let v = 3;
        if (isMd) {
            v = 1;
        }
        else if (isLg) {
            v = 2;
        }
        return Math.max(v - professionals.length, 0);
    }, [isMd, isLg, professionals]);
    const dummies = useArrayWithIndex(12);
    const { boolState: isMouseOver, changeFalse: onMouseLeave, changeTrue: onMouseOver, } = useBoolState();
    useEffect(() => {
        const interval = setInterval(() => {
            if (loading || isMouseOver || !sliderRef.current) {
                return;
            }
            sliderRef.current.slickNext();
        }, 3000);
        return () => {
            clearInterval(interval);
        };
    }, [loading, isMouseOver, sliderRef]);
    return (_jsx("div", Object.assign({ className: 'consultant-search-slider', onBlur: onMouseLeave, onFocus: onMouseOver, onMouseLeave: onMouseLeave, onMouseOver: onMouseOver }, { children: _jsx(CustomSlider, Object.assign({ config: config, fillCount: fillCount, setSliderRef: setSliderRef }, { children: loading && professionals.length === 0
                ? dummies.map(({ index }) => (_jsx(ProfessionalCardSkeleton, {}, `skeleton_${index}`)))
                : professionals.map((professional) => (_jsx(ProfessionalCard, { isPre: isPre, professional: professional, showPreModal: showPreModal, titleComponent: titleComponent }, professional.id))) })) })));
};
ConsultantSearchProfessionalSlider.propTypes = {
    config: propShape(),
    isLg: propBool().isRequired,
    isMd: propBool().isRequired,
    isPre: propBool().isRequired,
    loading: propBool().isRequired,
    professionals: propArrayShape().isRequired,
    showPreModal: propFunc().isRequired,
    titleComponent: propChildren(),
};
ConsultantSearchProfessionalSlider.defaultProps = {
    config: {},
    titleComponent: undefined,
};
export default ConsultantSearchProfessionalSlider;
